export default "__VITE_ASSET__MxHcdi6p__"